angular.module('mtic.components.modules.gr78').
directive('gr78MetaMap', function(
  GR78_ASSET_URL,
  AGENDA_ASSETS_URL,
  DEV_VARIABLES,
  StudentDataService,
  PanelStateService,
  $timeout,
  TIMING_CONSTANTS,
  TeacherDataService,
  $q,
  $log,
  $http,
  $window,
  gr78MapItemFactory,
  MapDataMassage,
  MapStateService,
  VerletSystemService,
  learningMapUtil,
  PIXI,
  EventManager,
  language,
  flashPermission,
  userAccount,
  preliveCheck,
  MODULE_AVAILABLE_LANGUAGE,
  LocaleService,
  ModuleFilter,
  PlatformService
) {

  return {

    templateUrl: 'template.html',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick:"<",
      workspaceData:"=?",
      interactionDisabled:"=?",
      disableVerlet:"=?",
      ocmtHse:"=?"
    },
    link: function(scope, element) {
      scope.getTranslation = function(id){
        return language.get(id);
      }
      scope.badBrowser = false;
      var middle_view_visible = false;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }

      scope.isTeacher = userAccount.getData().role.isTeacher;
      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78MetaMap', scope);
      var verlet_system = new VerletSystemService();
      if(scope.disableVerlet){
        verlet_system.toggle(false);
      }

      scope.goBackToClasses = function(){
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      }
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var state = 0,leftMostMapItemPosition=0,rightMostMapItemPosition=0,topMostMapItemPosition=0,allSummativeItems=[],languageOptions=[];
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_background = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var moduleContainerManager;
      var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));

      var agendas_list = [];

      var img_asset_paths = [
        GR78_ASSET_URL + "symlink.png",
        GR78_ASSET_URL + "item_blue_0.png",
        GR78_ASSET_URL + "item_blue_1.png",
        GR78_ASSET_URL + "item_red_0.png",
        GR78_ASSET_URL + "item_red_1.png",
        GR78_ASSET_URL + "item_red_2.png",
        GR78_ASSET_URL + "item_red_3.png",
        GR78_ASSET_URL + "item_black_0.png",
        GR78_ASSET_URL + "item_black_1.png",
        GR78_ASSET_URL + "item_black_2.png",
        GR78_ASSET_URL + "item_black_3.png",
        GR78_ASSET_URL + "item_blue_locked.png",
        GR78_ASSET_URL + "item_red_locked.png",
        GR78_ASSET_URL + "item_black_locked.png",
        GR78_ASSET_URL + "assessment.png",
        GR78_ASSET_URL + "assessment_complete.png",
        GR78_ASSET_URL + "selection.png",
        GR78_ASSET_URL + "mtic_gr78_m0.png",
        GR78_ASSET_URL + "mtic_gr78_m1.png",
        GR78_ASSET_URL + "mtic_gr78_m2.png",
        GR78_ASSET_URL + "mtic_gr78_m3.png",
        GR78_ASSET_URL + "mtic_gr78_m4.png",
        GR78_ASSET_URL + "mtic_gr78_c4_m1.png",
        GR78_ASSET_URL + "mtic_gr78_c4_m6.png",
        GR78_ASSET_URL + "formative_gold.png",
        GR78_ASSET_URL + "formative_silver.png",
        GR78_ASSET_URL + "formative_locked.png",
        GR78_ASSET_URL + "formative_unlocked.png",
      ]
      var focus_item = null;

      scope.hasAgendas = false;
      scope.loadedIframeModule = {
        active: false,
        data: []
      }
      scope.moduleProgress = 0.5;

      flashPermission.getPermission();

      var runDownModel = {}
      var highlightedItem = null;

      var zooming = false;

      var resourceLockManager = (function ResourceLockManager(self){
        var originalLockState = {};
        self.setOriginal = function(resourceId, isLocked){
          if(!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        }
        self.unlock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if(item) {
              item.unlock();
            }
          })
        }
        self.lock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if (TeacherDataService.isTeacherModuleView){
              item.unlock();
            }
            else{
              if(item) {
                item.lock();
              }
            }
          })
        }
        self.reset = function() {
          items.forEach(function(item){
            if (TeacherDataService.isTeacherModuleView){
              item.unlock();
            }
            else{
              if(originalLockState[item.id] === true) {
                item.lock();
              }
              else if(originalLockState[item.id] === false) {
                item.unlock();
              }
            }
          });
        }
        return self;
      })({})

      scope.showAgenda = false;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug){
        // $log.log('UNLOCK PATH : ', item_id, items )
        items.forEach(function(resource){
          if(resource.id === item_id || (use_slug && item_id === resource.slug)){
            resource.unlock();
            resource.unlockedByAgenda = true;
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                unlockpath(higher_resource, true);
              })
            }
          }
        })
      }

      eventManager.listen('moduleview:agenda:loaded', function(e, data){
        // $log.log('agenda data : ', data)
        if (data.length > 0)
        {
          agendas_list = data;
          scope.hasAgendas = true;
          // scope.toggleAgenda();
          scope.selectAgendaPanel();
          data.forEach(function(agenda){
            if(agenda.force_unlock){
              if(agenda.force_unlock){
                agenda.resources.forEach(function(item){
                  unlockpath(item);
                })
              }
            }
          })
        } else {
          scope.hasAgendas = false;
        }
      });

      scope.hasAgendaOption = function(){
        return scope.hasAgendas;
      }
      scope.hasModuleOption = function(){
        return scope.currentActiveSubModule && scope.currentActiveSubModule.children ;
      }

      scope.isShowingAgendaPanel = function(){
        return scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      }
      scope.isShowingModulePanel = function(){
        //&& scope.hasModuleOption()
        return (!scope.showAgenda  && !TeacherDataService.isTeacherWorkspaceView) || scope.isTeacher;
      }

      scope.toggleAgenda = function() {
        if (scope.showAgenda) {
          scope.selectModulePanel();
        }
        else {
          scope.selectAgendaPanel();
        }
      }

      scope.selectAgendaPanel = function(){
        // $log.log('from select agenda panel')
        scope.showAgenda = true;
        PanelStateService.setAgendaShowing(scope.showAgenda);
        if (!scope.showAgenda){
          eventManager.broadcast('moduleview:agenda:request');
        }
      }

      scope.selectModulePanel = function(){
        // $log.log('from select module panel')
        if (scope.showAgenda){
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      }

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function(){
        return !userAccount.getData().role.isTeacher;
      }

      /////////////
      // CONSTRUCTOR
      /////////////



      // if(MODULE_AVAILABLE_LANGUAGE[scope.moduleMapData.resource_slug]){
        // $log.log('no ?')
        // var allowed_langs = ["fr"];
        // language.setAvailableOptions(allowed_langs)
      // }


      var _TOUCHED_POINTS = []
      function init() {
        scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById('module-item-map-canvas');
        if (!canvas_el) {
          return;
        }

        MapStateService.setMetaStateSlug('mtic_gr78_m_meta')

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = 0.45;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        var sidepanel_width = 0;
        if(scope.isTeacher){
          // var sidepanel = document.getElementById('teacher_sidepanel');
          // sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
          // if(TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          //   sidepanel_width += -30;
          // }
        }

        canvasDimention = {
          width: 0,//window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50,
        }
        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);

        // if(TeacherDataService.isTeacherWorkspaceView){
        //   stage.x = -200;
        // }

        var meta_canvas = document.createElement("canvas");
        meta_canvas.width = 200;
        meta_canvas.height = 200;
        var ctx = meta_canvas.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 200);
        gradient.addColorStop(0, '#7DC5BA');
        gradient.addColorStop(1, '#A0E0DA');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 200, 200);

        var meta_tex = PIXI.Texture.fromCanvas(meta_canvas);

        meta_background = new PIXI.Sprite(meta_tex);
        stage.addChildAt(meta_background, 0);

        window.addEventListener("resize", onResize);

        // var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null
        // onResize(isExpanded);
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;

        stage.addChildAt(container, 1);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);


        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);
        // scope.test_data = 'TESTING';
        stage.on('pointerdown', function(e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x:e_o.pageX, y:e_o.pageY});

          drag_info.dragging = true;
          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };

        });
        stage.on('pointermove', function(e) {
          if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
            var mouse_pos = {
              x: e.data.global.x,
              y: e.data.global.y
            }
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
            var delta_pos = {
              x: drag_info.last_mouse_pos.x - mouse_pos.x,
              y: drag_info.last_mouse_pos.y - mouse_pos.y
            };
            drag_info.velocity = {
              x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
              y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
            };
            drag_info.last_mouse_pos = {
              x: mouse_pos.x,
              y: mouse_pos.y
            };
          }
        })
        stage.on('pointerup', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info)); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        // stage.on('pointermove', function(e){
        //   if(_TOUCHED_POINTS.length === 2){
        //     if(!prev_diff){
        //       prev_diff = Math.abs(_TOUCHED_POINTS[0].x - _TOUCHED_POINTS[1].x);
        //     }
        //     var e_o = e.data.originalEvent;
        //     var index = _TOUCHED_POINTS.findIndex(function(point, index) {
        //       if(point.pointer_id === e.pointerId){
        //         return true;
        //       }
        //     });

        //     _TOUCHED_POINTS[index].x = e_o.pageX;
        //     _TOUCHED_POINTS[index].y = e_o.pageY;

        //     var new_diff = Math.abs(_TOUCHED_POINTS[0].x - _TOUCHED_POINTS[1].x);

        //     $timeout(()=>{
        //       //scope.test_data = 'MOVING TWO :  ' + prev_diff + ' --- ' + new_diff;
        //       // _TOUCHED_POINTS.forEach((pt)=>{
        //       //   scope.test_data += '- POINT : X : '+pt.x+' Y: '+pt.y;
        //       // })
        //     })
        //   }
        // })
        stage.on('pointerout', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info)); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        if(PIXI.loader.resources){
          for(var ast in PIXI.loader.resources){
            PIXI.loader.reset();
            PIXI_gr78_Load_Cache = false;
            break;
          }
        }

        if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerdown ; ', JSON.stringify(drag_info)); }
        return loadAssets().then(function() {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null
          onResize(isExpanded);
          return;
        }).catch(function(err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message)
          $log.debug(err.stack)
        });


      }

      scope.returnToMetaModules = function() {
        scope.loadedIframeModule.active = false;
        eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
      }



      eventManager.listen('module:close:resource', function(e, data) {
        $timeout(function() {
          if(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta){
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta);
          }else if(languageOptions){
            language.setAvailableOptions(languageOptions);
          }
        }, 200)
      })

      eventManager.listen('module:change:meta', function(e, data) {
        $timeout(function() {
          meta_background.visible = true;
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');

          if(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta){
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta);
          }else if(languageOptions){
            language.setAvailableOptions(languageOptions);
          }

          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < modules.length; i++) {
            verlet_system.activateBody(modules[i].slug, true);

            modules[i].graphics.interactive = true;
          }
          onResize();
        },TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function(e, slug){
        items.forEach(function(resource){
          if(slug === resource.slug){
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        })
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      })
      eventManager.listen('module:change:submodule', function(e, data) {
        if(!languageOptions || languageOptions.length===0){
          languageOptions = language.getActiveLanguageOptions().map(lang=>lang.slug);
        }

        $timeout(function() {
          meta_background.visible = false;
          verlet_system.deactivateAllBodies(true);
          // $log.log('MODULE_AVAILABLE_LANGUAGE[data]', MODULE_AVAILABLE_LANGUAGE[data])
          if(MODULE_AVAILABLE_LANGUAGE[data]){
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[data])
          }

          MapStateService.setActiveModule(data);
          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                //unselect any highlited item
                var item = getItemBySlug(resource.children[n].slug);
                if(item && TeacherDataService.isTeacherWorkspaceView)
                {
                    item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1 || (resource.children[n].config && resource.children[n].config.hidden===true))
                {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          eventManager.broadcast('log:language:options', {
            available_language: scope.currentActiveSubModule.content.available_languages || 'none',
            current_url_version: LocaleService.getUrlVersion(),
            cycle: 'gr78'
          })
          language.setAvailableOptions(
            _.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion()])
          );
          if (!scope.hasAgendaOption()){
            scope.selectModulePanel();
          }
          // $log.log('from current active sub : ', scope.currentActiveSubModule)

          let isVerletNeeded = !scope.disableVerlet;
          if (scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.isVerletDisabled){
            isVerletNeeded = false;
          }
          verlet_system.toggle(isVerletNeeded);
          // $log.log('verlate is active : ' , isVerletNeeded, verlet_system.getCurrentEnabledStatus())

          if (scope.currentActiveSubModule.display.panel && scope.currentActiveSubModule.display ) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }
        }, TIMING_CONSTANTS.INSTANT);
      })

      eventManager.listen('module:open:resource', function(e, data){
        MapStateService.setFocusSlug(data.slug);
      })

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function(e,list){
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function(){
          onResize();
        }, 500)
      });

      eventManager.listen('module:select:resource', function(e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null)
        {
          eventManager.broadcast('module:dismiss:focus')
          return;
        }

        if(scope.onItemClick && scope.interceptClick){
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource,item, data);
          // return;
        }
        $timeout(function(){
          scope.selectedResource = scopeResource;
        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);

        //This isn't a map item??
        if (mapResource === null)
        {
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' ? 9.6 : 10

        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++)
        {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1 )
          {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug)
            {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name',{slug:scope.moduleMapData.resources[i].slug,name:scope.moduleMapData.resources[i].name});
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug);
            }
          }
        }


        if(TeacherDataService.inTeacherAgendaView && !middle_view_visible){
          middle_view_visible = true;
          onResize();
        }


      })

      eventManager.listen('module:center:resource', function(e, data) {
        focus_item = getItemBySlug(data.slug);
        // $log.log('FOCUS ON THIS : ', data)
      })

      eventManager.listen('module:stop:pan', function() {
        focus_item = null;
      })


      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};
        // $log.log("modulemapdata : ", moduleMapData)

        _.forEach(moduleMapData.children, function(someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        })



        var currentModuleChildrenDisplayItems = [];
        _.each(combinedResourceMap, function(resource) {
          var item = createItem(resource, null);
          if(!item){
            return;
          }
          currentModuleChildrenDisplayItems.push(item);
          if(item.sprite && item.sprite.position  && item.sprite.position.x<leftMostMapItemPosition){
            leftMostMapItemPosition = item.sprite.position.x;
          }
          if(item.sprite &&item.sprite.position && item.sprite.position.x && item.sprite.position.x>rightMostMapItemPosition){
            rightMostMapItemPosition = item.sprite.position.x;
          }
          if(item.sprite && item.sprite.position && item.sprite.position.y && item.sprite.position.y<topMostMapItemPosition){
            topMostMapItemPosition = item.sprite.position.y;
          }
        });

        // $log.log('currentModuleChildrenDisplayItems : ', moduleMapData)

        var summativeItem = _.find(currentModuleChildrenDisplayItems,function(each){
          return each.slug.indexOf('sum')>-1 && each.resource_type === 'assessment';
        });
        if(summativeItem){
          //  $log.log('summative g78 : ', summativeItem)
          summativeItem.sprite.position.set((leftMostMapItemPosition + (rightMostMapItemPosition-leftMostMapItemPosition)/2)-summativeItem.sprite.width/2,(topMostMapItemPosition -150));
          summativeItem.initialX = summativeItem.sprite.position.x;
          allSummativeItems.push(summativeItem);
        }

        _.forEach(items, function(item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        })

        if(agendas_list.length > 0){
          agendas_list.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })
        }

        eventManager.broadcast('creating-items-done');
      };

      var updateItemsHighlighterAnimation = function(){
        angular.forEach(items,function(each){
          if(each.selection_graphic){
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation-0.015)%(Math.PI*2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scope.scale_factor);
          }
          if(each.highlight_graphic){
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation-0.015)%(Math.PI*2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /10);
          }

        });
      }

      var prev_diff;

      //This loops to control things that should update every frame
      var update = function() {
        if(selection_graphic !== null && !scope.interceptClick)
        {

          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation-0.015)%(Math.PI*2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scope.scale_factor);
        }
        if(TeacherDataService.isTeacherWorkspaceView){
          updateItemsHighlighterAnimation();
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();

        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
          container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }

        focusItemTicker();

        lines_graphic.clear();
        if(!scope.ocmtHse){
          lines_graphic.lineStyle(8, 0xCCCCDD, 1);
          var segments = verlet_system.getLineSegments();
          var i;
          for (i = 0; i < segments.solid.length; i++) {
            var cur_seg = segments.solid[i];
            lines_graphic.lineStyle(8, 0xCCCCDD, 1);
            if(scope.item_path_slug.indexOf(cur_seg.id) > -1){
              lines_graphic.lineStyle(8, 0XFFCC00, 1);
            }
            lines_graphic.moveTo(cur_seg.start.x, cur_seg.start.y);
            lines_graphic.lineTo(cur_seg.end.x, cur_seg.end.y);
          }
          lines_graphic.beginFill(0xFF0000, 1);
          for (i = 0; i < segments.dash.length; i++) {
            lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
          }
          lines_graphic.endFill();
        }


        if (window.DEBUG_TOUCH){ $log.log('g78_metamap update ; ', JSON.stringify(drag_info)); }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug){
        if(!slug){
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function(resource){
          if(slug === resource.slug){
            scope.item_path_slug.push(slug);
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                createHighlightedSegments(higher_resource);
              })
            }
          }
        })
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function(e, data){
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if(data.clear){
          use = false;
        }
        createHighlightedSegments(use);
      })

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      }

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      }

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      }

      //If focus item is defined, pan towards it
      var focusItemTicker = function() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      }

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      }

      var getItemById = function(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      }

      var getResourceBySlug = function(slug)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++)
          {
            if (scope.moduleMapData.resources[n].children[i].slug === slug)
            {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      }

      ////////////////
      //
      ////////////////
      var onResize = function(sidepanel_expanded) {
        var _canvasEl = document.getElementById('module-item-map-canvas')
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
        var canv_width;
        // var sidepanel = document.getElementById('teacher_sidepanel');
        if(!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          if(sidepanel_expanded === true || sidepanel_expanded === false){
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          }else{
            sidepanel_width = 0;
          }
          canv_width =  _canvasEl.parentElement.offsetWidth - sidepanel_width;
        }else{
          var middleview = document.getElementById('agenda_middleview');
          if(middleview){
            sidepanel_width += 300
          }
          if(!TeacherDataService.inTeacherAgendaView){
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        }

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        meta_background.width = canvasDimention.width;
        meta_background.height = canvasDimention.height;


        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);


        if(container && renderer){
          scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
          container.scale.set(scale, scale);
          container.x = renderer.width / 2;
          container.y = renderer.height / 2;
        }
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function() {
        $log.debug('[[gr78MetaMap]] loadAssets')
        return $q(function(resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader
                .add(img_asset_paths)
                .load(function() {
                  // $log.debug('loaded resources', PIXI.loader.resources)
                  PIXI_gr78_Load_Cache = true;
                  initMap(resolve);
                })
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err)
            reject(err);
          }
        })
      }

      var initMap = function(resolve) {
        $log.debug('[[gr78MetaMap]] initMap')
        modules = [];
        var i, n, p;

        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)){
              //hide these
          }else{
            initMapDraw(scope.moduleMapData.resources[i]);
            //if(!scope.workspaceData || !scope.workspaceData.modules || scope.workspaceData.modules.length===0){
              var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
              modules.push(module_container);
            //}
          }

          //Add all the bad boys to the verlet_system
        }
        //moduleContainerManager.translationChanged();
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done')

        verlet_system.deactivateAllBodies(true);

        for (i = 0; i < modules.length; i++) {
          verlet_system.activateBody(modules[i].slug, true);
        }
        $log.debug('[[gr78MetaMap]] initMap.verlet_system done')
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              if (!item) {
                continue;
              }
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
        selection_graphic.anchor.set(0.5,0.5);
        selection_graphic.scale.set(0.75,0.75);
        selection_graphic.interactive = false;
        selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);

        if (!PanelStateService.agendaShowing())
        {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              // var item_evt_info = {
              //   slug : item_info.slug,
              //   id : item_info.id
              // };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_info);
              eventManager.broadcast('module:select:resource', item_info);
              if (focus_item === null) {
                break;
              }
              //center on the resource immediately
              if(focus_item){
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item)
        {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined)
          {
            $timeout(function(){
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }

        // $log.log('INIT MAP CONTAINER POSITION : ', container.x)
        // if(container && renderer){
        //   scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
        //   container.scale.set(scale, scale);
        //   container.x = renderer.width / 2;
        //   container.y = renderer.height / 2;
        // }

        $log.debug('[[gr78MetaMap]] initMap.active_module done')
        resolve();
      }

      var module_clicked = false;
      var moduleClicked = function(module_container) {
        if(scope.interactionDisabled){
          return;
        }
        module_clicked = true;

        // $log.log('MODULE CONTAINER : ', module_container)
        //DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module_container.slug) === -1 || preliveCheck.isQCCheck()
        // if(!(module_container.content && module_container.content.lock_on && is_module_locked(module_container.content.lock_on))) {
        if(ModuleFilter.checkAvailable(module_container)) {
          if(scope.interceptClick){
            if(scope.interceptClick.slug !== module_container.slug){
              scope.interceptClick.slug = module_container.slug;
            }else if(!TeacherDataService.inTeacherAgendaView){
              eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }

            scope.$apply();
          }
          var i;
          scope.moduleProgress = module_container.progress;
          $log.debug('[[gr78MetaMap]] clicked', module_container)

          if(module_container.content.container) {
            scope.loadedIframeModule.data = module_container;
            scope.loadedIframeModule.active = true;
          }
          else{
            for (i = 0; i < modules.length; i++) {
              modules[i].graphics.interactive = false;

              verlet_system.deactivateBody(modules[i].slug, true);
            }
            eventManager.broadcast('submodule:opened', {
              slug: module_container.slug,
              name: module_container.name
            })
            $timeout(function() {
              eventManager.broadcast('module:change:submodule', module_container.slug);
            }, TIMING_CONSTANTS.INSTANT);
          }
        }else{
          window.alert(language.get('module_is_locked'))
        }
      }


      var createModuleContainer = function(module, reset) {
          //Set up the container sprite that will be used
          var do_lock = module.locked;
          //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
          // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
          if (!ModuleFilter.checkAvailable(module)) {
            do_lock = true;
          }
        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        for (var i = 0; i < module.children.length; i++)
        {
          if (module.children[i].resource_type === 'symlink')
          {
            continue;
          }
          sum ++;
          if(TeacherDataService.isTeacherWorkspaceView){
            prog += workspace_list[module.children[i].id] ? 1 : 0;
          }else{
            prog += module.children[i].complete ? 1 : 0;
          }

        }
        if(TeacherDataService.isTeacherModuleView){
          prog = 0;
        }
        var mod_graphics;
        if(reset){
          modules.forEach(function(mod){
            if(mod.slug === module.slug){
              mod_graphics = mod.graphics;
            }
          })
          //mod_graphics = container.getChildAt(0);
          if(!mod_graphics){
            return;
          }
          mod_graphics.clear()
        }else{
          mod_graphics = new PIXI.Graphics();
        }
        mod_graphics.beginFill(do_lock ? 0xC5FBF5 : 0xFFFFFF).drawCircle(0, 0, 145).endFill() //white border
        .moveTo(0, 0)
        .beginFill(0x33ACE0).arc(0,0,146,-Math.PI/2, (prog/sum)*Math.PI*2-Math.PI/2); //progress ring
        var mod_image = PIXI.Sprite.fromImage(GR78_ASSET_URL + (do_lock ? "center_lock" : module.slug) + ".png");
        mod_image.anchor.set(0.5);
        var img_size = module.slug.indexOf('ocmt') > -1 ? 325 : 250;
        mod_image.width = img_size;
        mod_image.height = img_size;
        mod_graphics.addChild(mod_image);

        container.addChild(mod_graphics);
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;
        mod_graphics.x = module.display.position.x;
        mod_graphics.y = module.display.position.y + 300;
        // if(module.id === 69){
        //   mod_graphics.y -= 30;
        // }

        var tooltip = new PIXI.Graphics();
        mod_graphics.addChild(tooltip);

        var drawTooltip = () => {
          tooltip.removeChildren();
          tooltip.clear();

          var textInfo = new PIXI.Text(language.get(module.slug), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: isMobile ? 40 : 32,
            fill: 0xFFFFFF,
            dropShadow: false,
            wordWrap: true,
            wordWrapWidth: 400
          });

          tooltip.beginFill(do_lock ? 0x63a19a : 0x333c42);
          tooltip.drawRoundedRect(0,0, textInfo.width + 40, textInfo.height + 20, 8);
          tooltip.endFill();

          tooltip.addChild(textInfo);
          textInfo.position.set(20, 10);
          tooltip.position.set (-tooltip.width/2 , -tooltip.height - 170);
        }


        eventManager.listen('language:change', drawTooltip);
        drawTooltip();


        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          id: module.id,
          name: module.name,
          content: module.content,
          children: module.children,
          progress: prog/sum
        };
        if(reset){
          mod_graphics.off('pointertap')
        }
        mod_graphics.on('pointertap', function(e){
          //PIXI is receiving mouse events from other targets
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'module-item-map-canvas') {
            return;
          }
          $timeout(function(){
            if(!zooming){
              moduleClicked(module_container);
            }
          }, 10)
        });


        // eventManager.listen('destroy-c3-map', function(){
        //   PIXI_gr78_Load_Cache = false;
        // })


        eventManager.listen('module:dismiss:focus', function(e, data) {
          scope.selectedResource = {};
          if (selection_graphic && selection_graphic.parent !== null)
          {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });

        var connection = [];
        if (modules.length > 0) {
      //    connection.push(modules[modules.length - 1].slug);
        }

        verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      }

      var loadChildren = function(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function(childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      }
      var interpeteAgendaLockStatus = function(agenda){
        if(agenda.force_unlock === true) {
          return 'unlock';
        } else if(agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      }

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function(e, args) {
        $timeout(function(){
          summative_list.forEach(function(summ){
            if(args && args.unlocked.indexOf(summ.name) > -1){
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78')
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          })
        }, 500)

      });

      var createItem = function(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if((resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative') && !resource.config.show_summative){
          isSummative = true;
          if(!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({name: resource.slug, val: resource, parent: parentItem})
            return;
          }
        }else if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function(childItem) {
              createItem(childItem, parentItem);
            });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView){
          resource.locked = false;
        }
        //Add this to the map logic array of items
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked)
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        //Setup verlet body dragging
        /*
          displayItem.sprite.on('pointerdown', function(evt) {
            var dragFunc = function(tickerEvt) {
              var item = displayItem;
              var abs_pos = container.toGlobal(item.sprite.position);
              var xPos = renderer.plugins.interaction.eventData.data.global.x;
              var yPos = renderer.plugins.interaction.eventData.data.global.y;
              if (isNaN(xPos) || isNaN(yPos)) {
                return;
              }
              item.sprite.position.x -= abs_pos.x - xPos;
              item.sprite.position.y -= abs_pos.y - yPos;
            };

            stage.on('pointerup', function(e) {
              app.ticker.remove(dragFunc);
            });

            app.ticker.add(dragFunc);
            evt.stopPropagation();
          });
          */
        var children = [];
        //Build the child items
        _.forEach(resource.children, function(childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }


        // displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if(!isSummative){
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        }else{
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if(isSummative){
          resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if(force_unlock){
            displayItem.unlock(true);
          }
          displayItem.sprite.position.x = -900;
          displayItem.sprite.position.y = -500;
        }
        if(prehighlighted_list.indexOf(resource.id) > -1){
          // $log.log('PREHIGHLIGHTING : ', resource.slug)
          $timeout(function(){
            displayItem.showAgendaHighlight(true);
          }, 100);
        }
        return displayItem;
      }


      scope.$on('$destroy', function() {
        $log.log('from g78 map destroy')
        // language.resetAvilableOptions();
        EXISTS = false;
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if(item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);

        PIXI.loader.reset();
        PIXI_gr78_Load_Cache = false;
        stage.destroy(true);


        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {

          canvas_el.getContext('webgl').getExtension('WEBGL_lose_context').loseContext();
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        verlet_system.clear();
        app.destroy();
        modules = [];
        window.removeEventListener("resize", onResize);
      });

      scope.$watch("moduleMapData", function(moduleMapData) {
        if(!moduleMapData){
          return;
        }
        if(MODULE_AVAILABLE_LANGUAGE[moduleMapData.resource_slug] && !(MapStateService.getFocusSlug() !== "" && moduleMapData.resource_slug.indexOf('meta') > -1)){
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[moduleMapData.resource_slug])
        }
        for (var i = 0; i < moduleMapData.resources.length; i++) {
          switch (moduleMapData.resources[i].slug) {
            case 'mtic_gr78_m2':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapTwo(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m1':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m6':
                moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
                break;
          }
        }

        if (!moduleMapData || EXISTS) {
          return;
        }


        var timer = window.isWebEmbedConnect ? 500 : 0;
        $timeout(()=>{
          EXISTS = true;
          init();
        }, timer);
      })

      eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources)
        {
          return;
        }
        switch(interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });


      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function(val){
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;
        // $log.log('workspace data : ' , scope.workspaceData, items)
        $timeout(function(){
          if(scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)){
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach( function(user){
              users_list.push(user.user_id);
            })

            scope.workspaceData.modules.forEach( function(work){
              if(users_list.indexOf(work.user_id) > -1){
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            })

            //modules.forEach(function(built_mod){
              //container.removeChild(built_mod.graphics);
            //})

            // modules = [];
            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              if((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)){
                  //hide these
              }else{
                var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
                //modules.push(module_container);
              }
            }
          }
        }, timer)

        scope.itemSearchChange = function(val){
          scope.filteredNameList = [];
          if(!scope.itemsNameList){
            return;
          }
          if(val.trim() !== ''){
            scope.filteredNameList = scope.itemsNameList.filter(function(name){
              var nameMod = name.name.toLowerCase();
              var valMod = val.toLowerCase();
              var bool_val;
              try{
                bool_val = nameMod.match(valMod)
              }catch(e){
                bool_val = false
              }
              return bool_val;
            })
          }
          // $log.log('scope.filteredNameList', scope.filteredNameList);
        }

        scope.view_controller = {
          isStudentView: true,
          isModulePanelView: true,
          openSubMod: function(slug){
            // $log.log('opening sub mod:', slug)
            $timeout(function(){
              eventManager.broadcast('module:change:submodule', slug);
            }, 1000)
          },
          openMainMod: function(slug){
            eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
          }
        }

        eventManager.listen('sidepanel:toggled', function(e, val){
          if(!PlatformService.isPhonePortrait()){
            onResize(val);
          }
        })

        eventManager.listen('hide_item_selection_highlight', function(e, resource){
          var item = getItemBySlug(resource.slug);
          item.hideAgendaHighlight(true);
        })

        eventManager.listen('toggle_item_selection_highlight', function(e, slug){
          var item = getItemBySlug(slug);
          item.showAgendaHighlight();
        })

        scope.zoom_function = function(val){
          handleScroll({detail: val, preventDefault: ()=>{}})
          zooming = true;
          $timeout(function(){
            zooming = false
          }, 10)
        }

        eventManager.listen('offline-post-call-resolved', function(){
          if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked){
            for(var texture in PIXI.TextureCache){
              var tmp = PIXI.Texture.removeTextureFromCache(texture);
              tmp.destroy(true);
            }
            eventManager.broadcast('refresh:current:tab');
            eventManager.broadcast('student:cycle:open');
          }
        });

      })

    }
  }
});

var PIXI_gr78_Load_Cache;
var EXISTS;
